import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

class FormattedCurrency extends Component {
  render() {
    const {
      value,
      currency = "USD",
      symbol = "",
      currencyDisplay = 'none',
      useGrouping = true,
      minimumFractionDigits,
      maximumFractionDigits,
      intl: { formatNumber }
    } = this.props;

    const opts = {
      useGrouping,
      currency,
      style          : "currency",
      currencyDisplay: "code",
      minimumFractionDigits,
      maximumFractionDigits,
    };

    let formattedNumber = formatNumber( value, opts );
    if ( currencyDisplay === "none" ) {
      formattedNumber = formattedNumber.replace( currency, "" );
    } else if ( currencyDisplay === "symbol" ) {
      formattedNumber = formattedNumber.replace( currency, symbol );
    }

    return (
      <span>
        {formattedNumber}
      </span>
    );
  }
}

FormattedCurrency.propTypes = {
  value          : PropTypes.number.isRequired,
  currency       : PropTypes.string,
  symbol         : PropTypes.string,
  currencyDisplay: PropTypes.oneOf( [ "none", "code", "symbol" ] ),
  useGrouping    : PropTypes.bool,
};

export default injectIntl( FormattedCurrency );
